import React from 'react'
import ReactDOM from 'react-dom'
import styles from './Popover.scss'
import cx from 'classnames'

// All children MUST be li elements
export const Popover = ({mountOnBody, children, style, className, onClick, onMouseDown}) => {
  const component = (
    <div className={cx(styles.Popover, className)} style={style} onClick={onClick} onMouseDown={onMouseDown}>
      <ul>
        {children}
      </ul>
    </div>
  )
  if (mountOnBody) {
    return ReactDOM.createPortal(component, document.body)
  } else {
    return component
  }
}
